import React from 'react';

import { Button } from '@sopranodesign/pulse-components';

const NodeButton = props => {
  return (
    <Button
      onMouseDown={event => event.stopPropagation()}
      onMouseUp={event => event.stopPropagation()}
      {...props}
    />
  );
};

export default NodeButton;
